<section id="app-header" class="app-header">
  <div class="app-header-inner bg-color-primary">
    <div class="d-lg-none d-xl-none float-left" (click)="openSideMenu()">
      <span class="mat-button-wrapper mt-2 d-block">
        <mat-icon>menu</mat-icon>
      </span>
    </div>
    <div class="brand d-none d-lg-inline-block d-xl-inline-block">
      <h2>
        <span class="cursor-pointer" (click)="navigateToDashboard()">
          <img class="kortojura-icon" src="assets/images/kortojura_logo_circle.png" />
          <img class="brand-image" src="assets/images/kortojura_logo_title_white.png" />
        </span>
      </h2>
    </div>

    <!-- <div>This is a test. Added: 2022-03-02 @ 8.29</div> -->

    <div class="top-nav-left d-none d-lg-inline-block d-xl-inline-block">
      <ul class="list-unstyled list-inline">
        <li class="list-inline-item"></li>
      </ul>
    </div>
    <div class="top-nav-right">
      <ul class="list-unstyled">
        <li>
          <app-language-toggle className="md-button header-btn"> </app-language-toggle>
        </li>
        <li class="list-inline-item">
          <button mat-button class="md-button header-btn" [matMenuTriggerFor]="userMenu">
            <img class="rounded img30_30" src="assets/images/user_account.png" />
          </button>
          <mat-menu #userMenu="matMenu" x-position="after" y-position="below" overlapTrigger="false">
            <button (click)="navigateToProfile()" mat-menu-item>
              {{ 'Dashboard.ViewProfile' | translate }}
            </button>
            <button mat-menu-item (click)="logout()">
              {{ 'Dashboard.Logout' | translate }}
            </button>
          </mat-menu>
        </li>
      </ul>
    </div>
  </div>
  <mat-progress-bar appPreloader mode="indeterminate" color="accent" hidden></mat-progress-bar>
</section>
